import { render, staticRenderFns } from "./TransitionPage.vue?vue&type=template&id=5936012a&"
import script from "./TransitionPage.vue?vue&type=script&lang=js&"
export * from "./TransitionPage.vue?vue&type=script&lang=js&"
import style0 from "./TransitionPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports